/**
 * Tilauksen peruutus -vahvistusdialogi
 */

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import type { OrderListItem } from "@/types/orders";

interface CancelOrderDialogProps {
  order: OrderListItem | null;
  onClose: () => void;
  onConfirm: (orderId: string) => void;
}

export function CancelOrderDialog({
  order,
  onClose,
  onConfirm,
}: CancelOrderDialogProps) {
  return (
    <AlertDialog open={!!order} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Peru tilaus?</AlertDialogTitle>
          <AlertDialogDescription>
            Haluatko varmasti peruuttaa tilauksen {order?.order_number}?
            Peruutettu tilaus siirtyy arkistoon eikä sitä voi enää aktivoida.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Älä peruuta</AlertDialogCancel>
          <AlertDialogAction
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            onClick={() => {
              if (order) {
                onConfirm(order.id);
              }
            }}
          >
            Peru tilaus
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
